import { reactive } from 'vue'
import { useWebViewEventBus } from '@/composables/web-view-event-bus'

type WebViewPermissionResponse = {
  access_granted?: boolean
  access_denied_permanently?: boolean
}

type WebViewEnabledResponse = {
  enabled?: boolean
}

export function useBluetoothLocationAccess () {
  const webViewEventBus = useWebViewEventBus()

  const checkPermissions = async (feature: string) => {
    const permissions = await webViewEventBus.sendEventWithCallback(
      `${feature}.permissions`
    ) as WebViewPermissionResponse
    return {
      accessGranted: permissions.access_granted,
      accessDeniedPermanently: permissions.access_denied_permanently,
    }
  }

  const checkIfEnabled = async (feature: string) => {
    const data = await webViewEventBus.sendEventWithCallback(
      `${feature}.enabled`
    ) as WebViewEnabledResponse
    return data.enabled
  }

  const checkAccess = async (feature: string) => {
    const permissions = await checkPermissions(feature)
    const enabled = await checkIfEnabled(feature)
    return { ...permissions, enabled }
  }

  const location = reactive({
    accessGranted: false,
    accessDeniedPermanently: false,
    enabled: false,
  })

  return {
    location,
    checkPermissions,
    checkIfEnabled,
    checkAccess,
  }
}
